import { Search } from 'lucide-react';

interface TopTabsProps {
  activeTab: "Marketplace" | "Swipes";
  onTabChange: (tab: "Marketplace" | "Swipes") => void;
  tabs: string[];
  onSearchClick?: () => void;
}

export function TopTabs({ activeTab, onTabChange, tabs, onSearchClick }: TopTabsProps) {
  return (
    <div className="flex items-center gap-2">
      {/* Empty button for symmetry */}
      <button
        className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 opacity-0 pointer-events-none"
        aria-hidden="true"
      >
      </button>
      
      {/* Tab container - expands to fill space */}
      <div 
        className="flex gap-3 flex-1 p-1.5 rounded-2xl glass backdrop-blur-xl border border-white/10"
        style={{
          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.05)'
        }}
      >
        {tabs.map((tab) => {
          const isActive = activeTab === tab;
          
          return (
            <button
              key={tab}
              onClick={() => onTabChange(tab as "Marketplace" | "Swipes")}
              className="flex-1 px-1 sm:px-6 py-2.5 rounded-xl transition-all relative overflow-hidden font-medium flex items-center justify-center text-sm sm:text-base"
              style={{
                background: isActive 
                  ? 'linear-gradient(135deg, rgba(0, 255, 136, 0.15) 0%, rgba(0, 255, 136, 0.05) 100%)'
                  : 'transparent',
                color: isActive ? '#00FF88' : 'rgba(255, 255, 255, 0.5)',
                boxShadow: isActive 
                  ? '0 0 20px rgba(0, 255, 136, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.1)' 
                  : 'none',
                borderWidth: '1px',
                borderColor: isActive ? 'rgba(0, 255, 136, 0.3)' : 'transparent',
              }}
            >
              <span className="truncate">{tab}</span>
            </button>
          );
        })}
      </div>
      
      {/* Search button */}
      {onSearchClick && (
        <button
          onClick={onSearchClick}
          className="w-10 h-10 rounded-xl flex items-center justify-center glass border border-white/10 hover:border-splyt-green/50 hover:bg-white/10 transition-all flex-shrink-0"
        >
          <Search className="w-5 h-5 text-white" />
        </button>
      )}
    </div>
  );
}

